/**
 * Bekannte Befunde der Serverprüfung (`ApartmentPricingConfigurationValidator`) mit Feld und
 * deutschem Satz, dazu die Feldnamen für alle übrigen.
 */
export const FIELD_LABEL: Record<string, string> = {
  mode: 'Automationsmodus',
  strategyProfileVersionId: 'Strategie',
  currency: 'Währung',
  minimumPrice: 'Mindestpreis',
  referencePrice: 'Referenzpreis',
  maximumPrice: 'Maximalpreis',
  regularMinimumStay: 'Regulärer Mindestaufenthalt',
  fridaySaturdayMinimumStay: 'Mindestaufenthalt Freitag und Samstag',
  maximumGapLength: 'Längste Lücke',
  gapWithinDays: 'Tage für „nur kurzfristig“',
  minimumStayTiersEnabled: 'Vorlaufstaffel',
  minimumStayLeadTimeTiers: 'Vorlaufstaffel',
  calculationIntervalHours: 'Berechnungstakt',
  calculationStartLocalTime: 'Erster Lauf',
  publicationWindows: 'Übertragungsfenster',
  horizonDays: 'Planungshorizont',
  gapPolicy: 'Lückenregel',
  apartmentCurrency: 'Währung des Apartments',
};

/** Bekannte Servermeldungen mit ihrem Feld – das Feld gilt auch, wenn der Server keins nennt. */
export const KNOWN: Record<string, [field: string, text: string]> = {
  'Minimum price must not exceed reference price.': [
    'minimumPrice',
    'Der Mindestpreis darf nicht über dem Referenzpreis liegen.',
  ],
  'Reference price must not exceed maximum price.': [
    'referencePrice',
    'Der Referenzpreis darf nicht über dem Maximalpreis liegen.',
  ],
  'Price must be greater than zero.': ['', 'muss größer als null sein.'],
  'Price exceeds the supported money range.': ['', 'ist zu hoch.'],
  'Price must have at most two decimal places.': [
    '',
    'darf höchstens zwei Nachkommastellen haben.',
  ],
  'Regular minimum stay must be between 1 and 30 nights.': [
    'regularMinimumStay',
    'Der reguläre Mindestaufenthalt muss zwischen 1 und 30 Nächten liegen.',
  ],
  'Friday/Saturday minimum stay must be between 1 and 30 nights.': [
    'fridaySaturdayMinimumStay',
    'Der Mindestaufenthalt für Freitag und Samstag muss zwischen 1 und 30 Nächten liegen.',
  ],
  'Always gap policy must not define a day limit.': [
    'gapWithinDays',
    'Bei „immer“ gibt es keine Tagesgrenze.',
  ],
  'At most five minimum-stay lead-time tiers are allowed.': [
    'minimumStayLeadTimeTiers',
    'Höchstens fünf Vorlaufstufen sind möglich.',
  ],
  'Minimum-stay lead-time thresholds must be unique.': [
    'minimumStayLeadTimeTiers',
    'Jede Vorlaufschwelle darf nur einmal vorkommen.',
  ],
  'Minimum-stay lead-time tiers require an active pricing mode.': [
    'minimumStayTiersEnabled',
    'Die Vorlaufstaffel braucht einen eingeschalteten Modus.',
  ],
  'A minimum-stay lead-time tier may only lower the configured minimum stay.': [
    'minimumStayLeadTimeTiers',
    'Eine Vorlaufstufe darf den Mindestaufenthalt nur senken – höchstens so viele Nächte wie regulär und am Freitag/Samstag.',
  ],
  'Calculation interval must be 1, 3, 6, 12 or 24 hours.': [
    'calculationIntervalHours',
    'Der Berechnungstakt muss 1, 3, 6, 12 oder 24 Stunden sein.',
  ],
  'At least one publication window is required.': [
    'publicationWindows',
    'Mindestens ein Übertragungsfenster ist nötig.',
  ],
  'Publication window end must be after its start.': [
    'publicationWindows',
    'Das Ende eines Übertragungsfensters muss nach seinem Beginn liegen.',
  ],
  'Publication windows must not overlap.': [
    'publicationWindows',
    'Übertragungsfenster dürfen sich nicht überschneiden.',
  ],
  'Automatic pricing supports EUR only.': [
    'currency',
    'Vollautomatische Preise gibt es nur in Euro.',
  ],
  'Configuration currency must match the apartment currency.': [
    'currency',
    'Die Währung passt nicht zur Währung des Apartments.',
  ],
  'Currency must be a three-letter uppercase code.': ['currency', 'Die Währung ist ungültig.'],
  'The pricing strategy profile version does not exist.': [
    'strategyProfileVersionId',
    'Das gewählte Strategieprofil gibt es nicht mehr – bitte neu wählen.',
  ],
};

export const CODE_TEXT: Record<string, [field: string, text: string]> = {
  pricing_configuration_not_preview_ready: [
    'mode',
    'Für „Wirkung prüfen“ braucht es einen eingeschalteten Modus und alle Pflichtangaben.',
  ],
};
